import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

export function ShareLinkDialog({ open, onOpenChange, url }) {
  const { t } = useTranslation();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("shareDialog.copiedSuccess"));
    } catch (e) {
      toast.error(t("shareDialog.copyFailedError"));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-md" data-testid="share-link-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{t("shareDialog.title")}</DialogTitle>
          <DialogDescription>{t("shareDialog.description")}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input readOnly value={url || ""} data-testid="share-link-input" className="rounded-none" onFocus={(e) => e.target.select()} />
          <Button data-testid="share-link-copy-button" onClick={handleCopy} className="rounded-none gap-2 shrink-0">
            <Copy size={16} /> {t("shareDialog.copy")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
